import React, { PureComponent } from 'react';

import { Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography, Tooltip, FormControl, Select, MenuItem} from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import ReqIcon from '@material-ui/icons/AttachMoney';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
  icon: {
    marginLeft: 8,
    height: 20,
    verticalAlign: 'middle'
  },
  formControl: {
    margin: theme.spacing.unit,
    direction: 'column'
  },
});


class TeamStatusTable extends PureComponent {
  state = {
    filters: {
      division: 'all'
    },
  };

  componentDidMount() {
    const { userSeason } = this.props;
    //Retrieve the Divisions and Team data for the current Season
    if (userSeason) {
      this.props.getSeasonDivisions(userSeason);
      this.props.getTeamVolunteerData(userSeason);
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason } = this.props;
    //Re-retrieve Division and Team data when Season changes
    if (userSeason !== prevProps.userSeason) {
      this.props.getSeasonDivisions(userSeason);
      this.props.getTeamVolunteerData(userSeason);
      this.setState({ filters: { division: 'all' } });
    }
  }

  handleSelectChange = event => {
    const { value } = event.target;
    this.setState({ filters: { division: value }});
  };

  render() {
    const {
      seasonDivisions, seasonDivisionsList, fetchingSeasonDivisionsStatus,
      fetchingTeamVolunteerDataStatus
    } = this.props;
    const { classes } = this.props;
    let isLoaded = false;

    if (fetchingSeasonDivisionsStatus === 'Loaded' &&
        fetchingTeamVolunteerDataStatus === 'Loaded') isLoaded = true;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            <Typography variant="h5">
              Team Volunteers
            </Typography>
          </div>
          <div className={classes.spacer} />
          <FormControl>
            <Select 
              id="division"
              autoWidth={true}
              value={this.state.filters.division}
              onChange={this.handleSelectChange}
            >
              <MenuItem value="all">All Divisions</MenuItem>
              {seasonDivisionsList.map(division => {
                return (
                  <MenuItem key={division} value={seasonDivisions[division].name}>
                    {seasonDivisions[division].name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Toolbar>
        {isLoaded && this.renderTable()}
      </Paper>
    );
  }

  renderTable() {
    const { teams, teamsList } = this.props;
    const { classes } = this.props;
    let outputList = [];  

    if(this.state.filters.division !== 'all'){
      teamsList
      .filter(team => teams[team].division === this.state.filters.division)
      .map(team => {
        return outputList.push(team);
      });
    } else {
      teamsList
      .map(team => {
        return outputList.push(team);
      });
    }

    return (
      <Table padding="none">
        <TableHead>
          <TableRow>
            <TableCell padding="dense"><Typography variant="body1">Division</Typography></TableCell>
            <TableCell padding="dense"><Typography variant="body1">Team</Typography></TableCell>
            <TableCell padding="dense"><Typography variant="body1">Coach</Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">Umpires</Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">Committed</Typography></TableCell>        
            <TableCell align="center"><Typography variant="body1">Completed</Typography></TableCell>   
          </TableRow>
        </TableHead>
        <TableBody>
          {outputList.map((teamId) => {
            const team = teams[teamId];
            return (
              <TableRow className={classes.tablerow} key={teamId} hover>
                <TableCell padding="dense"><Typography variant="body1">{team.division}</Typography></TableCell>
                {this.renderTeamName(team)}
                <TableCell padding="dense"><Typography variant="body1">{team.firstName} {team.lastName}</Typography></TableCell>
                {this.renderUmpire(team.umpireCount, team.umpires)}
                <TableCell align="center"><Typography variant="body1">{team.gamesCommitted}</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">{team.gamesCompleted}</Typography></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }

  renderUmpire(count, umpires) {
    let umpNames = '';

    if (count > 0) {
      for (const umpId in umpires) {
        if (umpires.hasOwnProperty(umpId)) {
          const ump = umpires[umpId];
          umpNames += `${ump.firstName} ${ump.lastName} ${ump.gamesCommitted}/${ump.gamesCompleted} `;
        }
      }
      return (
      <Tooltip title={<Typography color="inherit" variant="body2">{umpNames}</Typography>}>
          <TableCell align="center"><Typography variant="body1">{count}</Typography></TableCell>
      </Tooltip>
      );
    }
    return (
      <TableCell align="center"><Typography variant="body1">{count}</Typography></TableCell>
    );
  }

  renderTeamName(team) {
    const { classes } = this.props;

    let gamesReq = (team.umpVolunteerGames > 0) ? 'Commitment completed!' : 'No volunteer commitment';
    if (team.gamesCompleted < team.umpVolunteerGames) {
      gamesReq = `${team.umpVolunteerGames-team.gamesCompleted} more volunteer games are required.`;
      return (
      <Tooltip title={<Typography color="inherit" variant="body2">{gamesReq}</Typography>}>
        <TableCell padding="dense">
          <Typography variant="body1">{team.name}<ReqIcon className={classes.icon} color="primary" /></Typography>
        </TableCell>
      </Tooltip>
      );
    }
    return (
      <Tooltip title={<Typography color="inherit" variant="body2">{gamesReq}</Typography>}>
        <TableCell padding="dense"><Typography variant="body1">{team.name}</Typography></TableCell>
      </Tooltip>
    );
  }

}

TeamStatusTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(TeamStatusTable);



// WEBPACK FOOTER //
// ./src/components/TeamStatusTableV2.js